
import {
  InsufficientAccessBackground,
  ProjectInstallationsHeaderSection,
  ProjectInstallationsSection,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import {
  Outlet,
  useLocation
} from 'react-router-dom';



export type InstallationsActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const InstallationsActivity = (props: InstallationsActivityProps) => {
  const location = useLocation();
  const access = useAccessState('Installation');

  if (!location.pathname.endsWith('installations')) {
    return <Outlet />;
  }


  return access.view
    ? (
      <StyledActivityCardBackground.FC>

        <ProjectInstallationsHeaderSection.FC />

        <ProjectInstallationsSection.FC />


      </StyledActivityCardBackground.FC>
    )
    : (
      <InsufficientAccessBackground.FC />
    );
};
